import React from "react";
import { Modal, Descriptions, Divider, Rate, Button } from "antd"; 
import { UserOutlined, StarFilled } from "@ant-design/icons";
import "./viewReviewRatingPanelPopup.css";

const ReviewRatingViewModal = ({ visible, reviewRatingData, onClose }) => {
  const formatDate = (dateString) => {
    if (!dateString) return "Not specified";
    return new Date(dateString).toLocaleDateString("en-IN", {
      year: "numeric",
      month: "long",
      day: "numeric",
    });
  };

  return (
    <Modal
      title={
        <div className="view-review-modal-header-content">
          <UserOutlined className="view-review-modal-header-icon" style={{ color: "white" }} />
          <span style={{ color: "white" }}>REVIEW DETAILS</span>
        </div>
      }
      open={visible}
      onCancel={onClose}
      footer={null}
      destroyOnClose
      width={800}
      className="view-review-modal-override"
      styles={{
        header: {
          background: "#0D152B",
          borderRadius: "12px 12px 0 0",
          padding: "20px 24px",
          borderBottom: "none",
        },
        body: {
          padding: "24px",
          background: "#fafafa",
        },
      }}
    >
      <div className="view-review-modal-content">
        <div className="view-review-card">
          <h3 className="view-review-card-header">Basic Information</h3>
          <div className="view-review-grid">
            <Descriptions column={2} bordered size="small">
              <Descriptions.Item label="Name">
                <span className="view-review-value">{reviewRatingData?.name || "N/A"}</span>
              </Descriptions.Item>
              <Descriptions.Item label="Profession">
                <span className="view-review-value">{reviewRatingData?.profession || "N/A"}</span>
              </Descriptions.Item>
              <Descriptions.Item label="Rating">
                <Rate 
                  disabled 
                  defaultValue={reviewRatingData?.rating || 0} 
                  character={<StarFilled style={{ fontSize: 16 }} />}
                  style={{ color: "#ffa500" }}
                />
                {/* <span style={{ marginLeft: 8 }}>({reviewRatingData?.rating})</span> */}
              </Descriptions.Item>
              <Descriptions.Item label="Created">
                {formatDate(reviewRatingData?.created_at)}
              </Descriptions.Item>
              <Descriptions.Item label="Updated">
                {formatDate(reviewRatingData?.updated_at)}
              </Descriptions.Item>
            </Descriptions>
          </div>
        </div>

        <Divider className="view-review-divider" />

        <div className="view-review-card">
          <h3 className="view-review-card-header">Profile Image</h3>
          <div className="view-review-image-container">
            {reviewRatingData?.image ? (
              <img
                src={reviewRatingData.image}
                alt="Profile"
                className="view-review-image"
              />
            ) : (
              <div className="view-review-no-image">
                <UserOutlined style={{ fontSize: 48, color: "#ccc" }} />
                <p>No image available</p>
              </div>
            )}
          </div>
        </div>

        <Divider className="view-review-divider" />

        <div className="view-review-card">
          <h3 className="view-review-card-header">Review Content</h3>
          <div className="view-review-text">
            <p>{reviewRatingData?.review || "No review content"}</p>
          </div>
        </div>

        <Divider className="view-review-divider" />

        <div className="view-review-actions">
          <Button
            size="large"
            onClick={onClose}
            className="view-review-btn view-review-btn-primary"
          >
            Close
          </Button>
        </div>
      </div>
    </Modal>
  );
};

export default ReviewRatingViewModal;
